import { FC } from 'react'

import { Input, InputProps } from '../Input'

export type PostalCodeInputProps = Omit<InputProps, 'onChange'> & {
  onChange: (value: string) => void
}

const PostalCodeInput: FC<PostalCodeInputProps> = ({ onChange, ...props }) => {
  return (
    <Input
      {...props}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

export { PostalCodeInput }
